export const apiUrl = 'https://api.tacom.srv.br';
export const praca = 'tfl';
export const apiLoginUrl = 'https://api.tacom.srv.br/authentication/v1/auth2/login';
export const username = 'tfl-web@tacom.com.br';
export const password = 'TFL(S1T7W3B';

export const versaoSoftware = '4.4.16';
export const idioma = 'pt_BR'

export default {
}